export const authRouter = {
  path: '/auth',
  name: 'Auth',
  component: () => import('@/views/auth/MainAuth'),
  children: [
    {
      path: '/auth/sign-in',
      name: 'Sign in',
      component: () => import('@/views/auth/SignIn')
    },
    {
      path: '/auth/forgot-password',
      name: 'Forgot password',
      component: () => import('@/views/auth/RequestPasswordReset')
    },
    {
      path: '/auth/reset-password',
      name: 'Reset password',
      component: () => import('@/views/auth/ResetPassword')
    },
    {
      path: '/auth/reset-blacklist',
      name: 'Reset Blacklist',
      component: () => import('@/views/auth/ResetBlacklist')
    }
  ]
}

export const printRouter = {
  path: '/print',
  name: 'Print',
  meta: { requiresAuth: true },
  component: () => import('@/views/print/MainPrint'),
  children: [
    {
      path: 'production/:id',
      name: 'Print production',
      props: true,
      component: () => import('@/views/production/PrintProduction/PrintProduction')
    },
    {
      path: 'delivery/:id',
      name: 'Print Delivery',
      props: true,
      component: () => import('@/views/deliveries/print/delivery/doc')
    },
    {
      path: 'delivery/labels/:id',
      name: 'Print Delivery Labels',
      props: true,
      component: () => import('@/views/deliveries/print/Labels')
    },
    {
      path: 'sales-quote/:id',
      name: 'Print Sales Quote',
      props: true,
      component: () => import('@/views/sales-quotes/print/Quote')
    },
    {
      path: 'sales-invoice/:id',
      name: 'Print Sales Invoice',
      props: true,
      component: () => import('@/views/sales-invoices/print/Invoice')
    },
    {
      path: 'packing-slip/:id',
      name: 'Print Packing Slip',
      props: true,
      component: () => import('@/views/sales/sale/print/Document')
    }
  ]
}

export const testRouter = {
  path: '/test',
  name: 'TestMain',
  component: () => import('@/views/test/Test'),
  children: [
    {
      path: '/dummy-test',
      name: 'Test page',
      component: () => import('@/views/test/Test')
    }
  ]
}

export const userRouter = {
  path: '/user',
  name: 'userRouter',
  redirect: '/user/profile',
  component: () => import('@/views/Main'),
  meta: { requiresAuth: true },
  children: [
    {
      path: 'profile',
      name: 'Profile',
      component: () => import('@/views/user/profile/Profile')
    }
  ]
}

export const loadingRouter = {
  path: '/loading',
  name: 'Loading',
  meta: {
    title: 'Loading . . .',
    requiresAuth: true
  },
  component: () => import('@/views/loading/Loading')
}

export const appRouter = [
  {
    path: '/',
    name: 'appRouter',
    redirect: '/dashboard',
    component: () => import('@/views/Main'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '/accounting',
        name: 'Accounting',
        component: () => import('@/views/accounting/Main')
      },
      {
        path: '/developer-docs',
        name: 'Developer Docs',
        component: () => import('@/views/developer-docs/DeveloperDocs')
      },
      {
        path: '/documentation',
        name: 'Documentation',
        component: () => import('@/views/documentation/Documentation')
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/Dashboard')
      },
      {
        path: '/admin/users',
        name: 'Users',
        props: true,
        component: () => import('@/views/users/Users')
      },
      {
        path: '/admin/server-statistics',
        name: 'Server statistics',
        props: true,
        component: () => import('@/views/admin/server-statistics/Main')
      },
      {
        path: '/internal-codes',
        name: 'Internal Codes',
        component: () => import('@/views/internal-codes/InternalCodes')
      },
      {
        path: '/deliveries',
        name: 'Deliveries',
        component: () => import('@/views/deliveries/DeliveriesList')
      },
      {
        path: '/delivery/:id',
        name: 'Delivery',
        props: true,
        component: () => import('@/views/deliveries/DeliveryMain')
      },
      /*
      {
        path: '/inventory/item/:id',
        name: 'Inventory Item Group',
        props: true,
        component: () => import('@/views/inventory/InventoryItemGroup')
      },
      */
      {
        path: '/inventory-tx',
        name: 'Inventory Transactions',
        component: () => import('@/views/inventory-tx/Main')
      },
      {
        path: '/inventory-tx/:id',
        name: 'View Inventory Transaction',
        props: true,
        component: () => import('@/views/inventory-tx/tx/InventoryTX')
      },
      {
        path: '/inventory/inventory-definitions',
        name: 'Inventory Definitions',
        component: () => import('@/views/inventory-definitions/InventoryDefinitionsList')
      },
      {
        path: '/inventory/inventory-definitions/new',
        name: 'New Inventory Definition',
        component: () => import('@/views/inventory-definitions/CreateNew')
      },
      {
        path: '/inventory/inventory-definitions/edit/:id',
        name: 'Edit Inventory Definition',
        props: true,
        component: () => import('@/views/inventory-definitions/Edit')
      },
      {
        path: '/inventory/inventory-definition/view/:id',
        name: 'View Inventory Definition',
        props: true,
        component: () => import('@/views/inventory-definitions/ViewDefinition')
      },
      {
        path: '/inventory/inventory-definition/build/:id',
        name: 'Edit Build',
        props: true,
        component: () => import('@/views/builds/Build')
      },
      {
        path: '/mileage',
        name: 'Mileage',
        component: () => import('@/views/mileage/Mileage')
      },
      {
        path: '/samples',
        name: 'Samples',
        component: () => import('@/views/samples/Samples')
      },
      {
        path: '/trace/:id',
        name: 'Archive Trace',
        props: true,
        component: () => import('@/views/trace/ArchiveItem')
      },
      {
        path: '/forecast',
        name: 'Forecast',
        component: () => import('@/views/forecast/Main')
      },
      {
        path: '/notifications',
        name: 'Notifications',
        component: () => import('@/views/notifications/Notifications')
      },
      {
        path: '/returns',
        name: 'Returns',
        component: () => import('@/views/returns/ReturnsList')
      },
      {
        path: '/suppliers',
        name: 'Suppliers',
        component: () => import('@/views/suppliers/SuppliersList')
      },
      {
        path: '/customers',
        name: 'Customers',
        component: () => import('@/views/customers/CustomersList')
      },
      {
        path: '/customer/:id',
        props: true,
        name: 'Customer',
        component: () => import('@/views/customers/customer/Edit')
      },
      {
        path: '/customers/new',
        name: 'Customer New',
        component: () => import('@/views/customers/customer/New')
      },
      {
        path: '/settings',
        name: 'Settings',
        component: () => import('@/views/settings/Settings')
      },
      {
        path: '/currencies',
        name: 'Currencies',
        component: () => import('@/views/currencies/Main')
      },
      {
        path: '/form',
        name: 'Form',
        component: () => import('@/views/form-route/FormView')
      },
      // new productions
      {
        path: '/productions/production/:id/output-staging/:outputID',
        name: 'Production output staging',
        props: true,
        component: () => import('@/views/productions-new/production/output-staging/Staging')
      },
      {
        path: '/productions',
        name: 'Productions',
        component: () => import('@/views/production/ProductionsList')
      },
      {
        path: '/production/:id',
        name: 'Production',
        props: true,
        component: () => import('@/views/production/Production')
      },
      {
        path: '/production/:id/output/edit/:outputId',
        name: 'Add Production Output',
        props: true,
        component: () => import('@/views/production/add-production-output/AddProductionOutput')
      },
      {
        path: '/production/:id/output/new',
        name: 'New Production Output',
        props: true,
        component: () => import('@/views/production/add-production-output/AddProductionOutput')
      },
      {
        path: '/sales',
        name: 'Sales',
        props: true,
        component: () => import('@/views/sales/Sales')
      },
      {
        path: '/sale/:id',
        props: true,
        name: 'Sale',
        component: () => import('@/views/sales/sale/sale')
      },
      {
        path: '/sales-quotes',
        name: 'Sales Quotes',
        component: () => import('@/views/sales-quotes/Quotes')
      },
      {
        path: '/sales-quote/:id',
        props: true,
        name: 'Sales Quote',
        component: () => import('@/views/sales-quotes/sales-quote/Edit')
      },
      {
        path: '/invoices',
        name: 'Invoices',
        component: () => import('@/views/sales-invoices/Invoices')
      },
      {
        path: '/invoice/:id',
        props: true,
        name: 'Invoice',
        component: () => import('@/views/sales-invoices/sales-invoice/Edit')
      },
      {
        path: '/price-lists',
        name: 'Price Lists',
        component: () => import('@/views/price-lists/PriceLists')
      },
      {
        path: '/price-list/:id',
        props: true,
        name: 'Price List',
        component: () => import('@/views/price-lists/price-list/combo-card')
      },
    ]
  }
]

export const page404 = {
  path: '/*',
  name: 'error-404',
  meta: {
    title: '404-Page does not exist'
  },
  component: () => import('@/views/error-page/404')
}

export const routers = [
  loadingRouter,
  testRouter,
  authRouter,
  userRouter,
  printRouter,
  ...appRouter,
  page404
]
